import { lazy } from 'react';
import ToolbarBootstrap from './Toolbar/ToolbarBootstrap.js.jsx';

const bootstraps = {
  ToolbarBootstrap,
  EventsBootstrap: lazy(() => import(/* webpackChunkName: "EventsBootstrap" */ './Events/EventsBootstrap')),
  CalendarBootstrap: lazy(() => import(/* webpackChunkName: "CalendarBootstrap" */ './CalendarV2/CalendarBootstrap')),
  HealthCheck: lazy(() => import(/* webpackChunkName: "HealthCheck" */ './HealthCheck/HealthCheck.js.jsx')),
  ProLoginScreenBootstrap: lazy(() =>
    import(/* webpackChunkName: "ProLoginScreenBootstrap" */ './Login/ProLoginScreenBootstrap.jsx')
  ),
  SettingsParent: lazy(() => import(/* webpackChunkName: "SettingsParent" */ './Settings/SettingsParent.js.jsx')),
  ActivityFeed: lazy(() => import(/* webpackChunkName: "ActivityFeed" */ './Toolbar/ActivityFeed/ActivityFeed.js.jsx')),
  TimeTrackingReportParent: lazy(() =>
    import(/* webpackChunkName: "TimeTrackingReportParent" */ './TimeTracking/TimeTrackingReportParent.js.jsx')
  ),
  TasksStandalone: lazy(() => import(/* webpackChunkName: "TasksStandalone" */ './Toolbar/Tasks/TasksStandalone.jsx')),
  JobPreviewBootstrap: lazy(() =>
    import(/* webpackChunkName: "JobPreviewBootstrap" */ './Job/JobPreviewBootstrap.jsx')
  ),
  ArchivedJobsBootStrap: lazy(() =>
    import(/* webpackChunkName: "ArchivedJobsBootStrap" */ './Job/List/ArchivedJobsBootStrap.jsx')
  ),
  AutoBillReviewCard: lazy(() =>
    import(/* webpackChunkName: "AutoBillReviewCard" */ './Job/AutoBillReviewCard.js.jsx')
  ),
  TextNotificationBootstrap: lazy(() =>
    import(
      /* webpackChunkName: "TextNotificationBootstrap" */ './Settings/TextNotification/TextNotificationBootstrap.js.jsx'
    )
  ),
  Bootstrap: lazy(() => import(/* webpackChunkName: "Bootstrap" */ './Job/Details/Bootstrap.js.jsx')),
  EstimateBootstrap: lazy(() => import(/* webpackChunkName: "EstimateBootstrap" */ './Estimate/EstimateBootstrap.tsx')),
  CreateJobBootstrap: lazy(() =>
    import(/* webpackChunkName: "CreateJobBootstrap" */ './Job/CreateJob/CreateJobBootstrap.jsx')
  ),
  InstabookBootstrap: lazy(() =>
    import(
      /* webpackChunkName: "InstabookBootstrap" */ './Settings/PriceList/InstabookPriceList/InstabookBootstrap.js.jsx'
    )
  ),
  MyMoneyBootstrap: lazy(() => import(/* webpackChunkName: "MyMoneyBootstrap" */ './MyMoney/MyMoneyBootstrap.js.jsx')),
  BillingBootstrap: lazy(() =>
    import(/* webpackChunkName: "BillingBootstrap" */ './Settings/Billing/BillingBootstrap.jsx')
  ),
  DashboardBootstrap: lazy(() =>
    import(/* webpackChunkName: "DashboardBootstrap" */ './Dashboard/DashboardBootstrap.jsx')
  ),
  MyJobsBootstrap: lazy(() => import(/* webpackChunkName: "MyJobsBootstrap" */ './MyJobs/MyJobsBootstrap.jsx')),
  ReportsBootstrap: lazy(() => import(/* webpackChunkName: "ReportsBootstrap" */ './Reports/ReportsBootstrap.jsx')),
  SettingsBootstrap: lazy(() => import(/* webpackChunkName: "SettingsBootstrap" */ './Settings/SettingsBootstrap.tsx')),
  ReviewsBootstrap: lazy(() =>
    import(/* webpackChunkName: "ReviewsBootstrap" */ './Apps/Reviews/ReviewsBootstrap.jsx')
  ),
  CreateProposalBootstrap: lazy(() =>
    import(/* webpackChunkName: "CreateProposalBootstrap" */ './Job/CreateProposal/CreateProposalBootstrap.jsx')
  ),
  CreateOCAProposalBootstrap: lazy(() =>
    import(
      /* webpackChunkName: "CreateOCAProposalBootstrap" */ './Integrations/OnCallAir/CreateOCAProposalBootstrap.jsx'
    )
  ),
  ServiceAreaParent: lazy(() =>
    import(/* webpackChunkName: "ServiceAreaParent" */ './Account/ServiceArea/ServiceAreaParent.js.jsx')
  ),
  NoAccessBootstrap: lazy(() => import(/* webpackChunkName: "NoAccessBootstrap" */ './NoAccessBootstrap.tsx')),
  AcceptTos: lazy(() => import(/* webpackChunkName: "AcceptTos" */ './Account/AcceptTos/AcceptTos.jsx')),
  ResetPasswordBootstrap: lazy(() =>
    import(/* webpackChunkName: "ResetPasswordBootstrap" */ './Account/ResetPassword/ResetPasswordBootstrap.jsx')
  ),
  ForgotPasswordBootstrap: lazy(() =>
    import(/* webpackChunkName: "ForgotPasswordBootstrap" */ './Account/ForgotPassword/ForgotPasswordBootstrap.jsx')
  ),
  DoorkeeperAuthorizationBootstrap: lazy(() =>
    import(
      /* webpackChunkName: "DoorkeeperAuthorizationBootstrap" */ './Doorkeeper/DoorkeeperAuthorizationBootstrap.jsx'
    )
  ),
  AppsParent: lazy(() => import(/* webpackChunkName: "AppsParent" */ './Apps/AppsPage/AppsParent.jsx')),
  AppDetailsParent: lazy(() =>
    import(/* webpackChunkName: "AppDetailsParent" */ './Apps/AppDetails/AppDetailsParent.js.jsx')
  ),
  SetupBootstrap: lazy(() => import(/* webpackChunkName: "SetupBootstrap" */ './Setup/SetupBootstrap.jsx')),
  WebsiteOnboardingBootstrap: lazy(() =>
    import(/* webpackChunkName: "WebsiteOnboardingBootstrap" */ './WebsiteOnboarding/WebsiteOnboardingBootstrap.jsx')
  ),
  PayWallBootstrap: lazy(() => import(/* webpackChunkName: "PayWallBootstrap" */ './PayWall/PayWallBootstrap.tsx')),
  UpgradeNowPayWallBootstrap: lazy(() =>
    import(/* webpackChunkName: "UpgradeNowPayWallBootstrap" */ './PayWall/UpgradeNowPayWallBootstrap.tsx')
  ),
  OnEventPayWallBootstrap: lazy(() =>
    import(/* webpackChunkName: "OnEventPayWallBootstrap" */ './PayWall/OnEventPayWallBootstrap.tsx')
  ),
  CustomersBootstrap: lazy(() =>
    import(/* webpackChunkName: "CustomersBootstrap" */ './Customers/CustomersBootstrap.jsx')
  ),
  AddOrEditCustomerDialogWrapper: lazy(() =>
    import(
      /* webpackChunkName: "AddOrEditCustomerDialogWrapper" */ './Customers/AddOrEditCustomer/AddOrEditCustomerDialogWrapper.jsx'
    )
  ),
  BetaInactiveBanner: lazy(() =>
    import(/* webpackChunkName: "BetaInactiveBanner" */ './Common/NoticeBar/BetaInactiveBanner.jsx')
  ),
  GratuitySwitch: lazy(() => import(/* webpackChunkName: "GratuitySwitch" */ './CompanyProfile/GratuitySwitch.jsx')),
  IntegrationsBootstrap: lazy(() =>
    import(/* webpackChunkName: "IntegrationsBootstrap" */ './Integrations/IntegrationsBootstrap.jsx')
  ),
  AppBootstrap: lazy(() => import(/* webpackChunkName: "AppBootstrap" */ './AppBootstrap.jsx')),
  Charges: lazy(() => import(/* webpackChunkName: "Charges" */ './Admin/Charges/Charges.js.jsx')),
  ChargeHistoryOverview: lazy(() =>
    import(/* webpackChunkName: "ChargeHistoryOverview" */ './Admin/ChargeHistory/ChargeHistoryOverview.js.jsx')
  ),
  CommissionsReport: lazy(() =>
    import(/* webpackChunkName: "CommissionsReport" */ './Admin/CommissionsReport/CommissionsReport.js.jsx')
  ),
  MoveProToOrg: lazy(() => import(/* webpackChunkName: "MoveProToOrg" */ './Admin/Organization/MoveProToOrg.js.jsx')),
  Organization: lazy(() => import(/* webpackChunkName: "Organization" */ './Admin/Organization/Organization.js.jsx')),
  ProductFeedbackDashboard: lazy(() =>
    import(/* webpackChunkName: "ProductFeedbackDashboard" */ './Admin/ProductFeedback/ProductFeedbackDashboard.js.jsx')
  ),
  AdminBootstrap: lazy(() => import(/* webpackChunkName: "AdminBootstrap" */ './AdminNew/AdminBootstrap.jsx')),
  ProposalPrintPreview: lazy(() =>
    import(/* webpackChunkName: "ProposalPrintPreview" */ './Proposal/ProposalPrintPreview.jsx')
  ),
  FranchiseAddJob: lazy(() => import(/* webpackChunkName: "FranchiseAddJob" */ './Franchise/FranchiseAddJob.jsx')),
  HqDashboard: lazy(() => import(/* webpackChunkName: "HqDashboard" */ './Hq/Dashboard/HqDashboardBootstrap.jsx')),
  SafeModeBootstrap: lazy(() => import(/* webpackChunkName: "SafeModeBootstrap" */ './Outage/SafeModeBootstrap.jsx')),
  EstimateFooter: lazy(() => import(/* webpackChunkName: "SafeModeBootstrap" */ './Invoice/EstimateFooter.jsx')),
  ChatBootstrap: lazy(() => import(/* webpackChunkName: "ChatBootstrap" */ './Chat/ChatBootstrap.jsx')),
  LeadsBootstrap: lazy(() => import(/* webpackChunkName: "LeadsBootstrap" */ './Leads/LeadsBootstrap.tsx')),
  JobInboxBootstrap: lazy(() => import(/* webpackChunkName: "JobInboxBootstrap" */ './JobInbox/JobInboxBootstrap.jsx')),
  TwoFactorAuthenticationBootstrap: lazy(() =>
    import(
      /* webpackChunkName: "TwoFactorAuthenticationBootstrap" */ './Authenticate/TwoFactorAuthenticationBootstrap.tsx'
    )
  ),
  OnlineBookingPreviewBootstrap: lazy(() =>
    import(
      /* webpackChunkName: "OnlineBookingPreviewBootstrap" */ './OnlineBookingSettings/pages/OnlineBookingPreviewBootstrap.tsx'
    )
  ),
  HomeOwnerFlowWidget: lazy(() =>
    import(/* webpackChunkName: "HomeOwnerFlowWidget" */ './OnlineBooking/HomeOwnerFlowWidget.tsx')
  ),
  OnlineBookingOnboardingBootstrap: lazy(() =>
    import(
      /* webpackChunkName: "OnlineBookingOnboarding" */ './OnlineBookingOnboarding/OnlineBookingOnboardingBootstrap.tsx'
    )
  ),
  PayrollMobileSelfOnboardingBootstrap: lazy(() =>
    import(
      /* webpackChunkName: "PayrollMobileSelfOnboardingBootstrap" */ 'components/MyMoneyV2/Payroll/Onboarding/StaffSelfOnboarding/Mobile/PayrollMobileSelfOnboardingBootstrap.tsx'
    )
  ),
  PayrollTokenBasedSelfOnboardingBootstrap: lazy(() =>
    import(
      /* webpackChunkName: "PayrollTokenBasedSelfOnboardingBootstrap" */ 'components/MyMoneyV2/Payroll/Onboarding/StaffSelfOnboarding/Token/PayrollTokenBasedSelfOnboardingBootstrap.tsx'
    )
  ),
};

export default bootstraps;
